export const COMPANY_LIST_LIMIT = 10;
